import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Group, GroupDetails } from './group-model';
import { UserData } from '../users-database/user-model';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import {
  ApiResponse,
  Meta,
} from '../../../../common/models/api-response.model';
import { Option } from '../../../../common/models/option.model';
import { SearchEnum } from '../../../../common/enums/search.enum';

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  http = inject(HttpClient);
  readonly GROUP_ID = '{groupId}' as const;

  getGroupList(
    page: number,
    per_page: number,
    filter: string,
    sort?: { key: string; value: 'asc' | 'desc' },
    search?: string
  ) {
    let params = new HttpParams()
      .append('page', page)
      .append('per_page', per_page);
    if (filter && filter !== 'all') {
      params = params.append('filters[state]', filter);
    }
    if (sort?.key) {
      params = params.append(`sort[${sort.key}]`, sort.value);
    }
    if (search) {
      params = params.append(SearchEnum.keyword, search);
    }
    return this.http.get<ApiResponse<Group>>(ENDPOINTS.Dashboard.Groups.List, {
      params,
    });
  }

  getGroup(id: string) {
    return this.http.get<{ data: GroupDetails }>(
      ENDPOINTS.Dashboard.Groups.Details.replace(this.GROUP_ID, id)
    );
  }

  getGroupUsers(
    groupId: string,
    page: number,
    per_page: number,
    searchName = ''
  ) {
    const params = new HttpParams()
      .append('page', page)
      .append('per_page', per_page)
      .append('filters[search]', searchName);

    return this.http.get<ApiResponse<UserData>>(
      ENDPOINTS.Dashboard.Groups.Users.replace(this.GROUP_ID, groupId),
      { params }
    );
  }

  addGroup(data: any) {
    return this.http.post(ENDPOINTS.Dashboard.Groups.Create, data);
  }

  updateGroup(data: any, id: string) {
    return this.http.put(
      ENDPOINTS.Dashboard.Groups.Update.replace(this.GROUP_ID, id),
      data
    );
  }

  changeGroupState(data: any, groupId: string) {
    return this.http.put(
      ENDPOINTS.Dashboard.Groups.ChangeState.replace(this.GROUP_ID, groupId),
      data
    );
  }

  deleteGroup(groupId: string) {
    return this.http.delete(
      ENDPOINTS.Dashboard.Groups.Delete.replace(this.GROUP_ID, groupId)
    );
  }

  groupLookup(
    name: string,
    page: number,
    showActiveOnly = false,
    userId = '',
    perPage = 15
  ) {
    let params = new HttpParams()
      .append('filters[search]', name)
      .append('page', page)
      .append('per_page', perPage);

    if (showActiveOnly) {
      params = params.append('filters[state]', 'active');
    }

    if (userId) {
      params = params.append('filters[not_user][id]', userId);
    }

    return this.http.get<{ data: Option[]; meta: Meta }>(
      ENDPOINTS.Lookup.Groups,
      { params }
    );
  }
}
